import type { VMAgentPackageDataSource } from '@/types';

export function vmAgentPackageReviewAPIPath(
  source: VMAgentPackageDataSource,
  suffix = '',
) {
  if (source !== 'tutti-v2') {
    throw new Error('Unsupported agent package source');
  }
  const prefix = '/api/v2';
  return `${prefix}/vm-agent-package-reviews${suffix}`;
}
